import { parsePhoneNumberFromString } from 'libphonenumber-js';

// La regex sólo controla la sintaxis de entrada. La validez real (prefijo,
// longitud y plan nacional) la determina libphonenumber con metadata mundial.
const SINTAXIS_INTERNACIONAL = /^(?:\+|00)[0-9\s()./-]+$/;

export const validarTelefonoInternacional = (valor, { obligatorio = false } = {}) => {
  const entrada = String(valor || '').trim();
  if (!entrada) return { valido: !obligatorio, vacio: true, error: obligatorio ? 'vacio' : null, numero: '' };
  if (!SINTAXIS_INTERNACIONAL.test(entrada)) return { valido: false, vacio: false, error: 'formato', numero: '' };

  const internacional = entrada.startsWith('00') ? `+${entrada.slice(2)}` : entrada;
  const compacto = `+${internacional.slice(1).replace(/\D/g, '')}`;
  const telefono = parsePhoneNumberFromString(compacto);
  if (!telefono || !telefono.isPossible() || !telefono.isValid()) {
    return { valido: false, vacio: false, error: 'invalido', numero: '' };
  }

  return { valido: true, vacio: false, error: null, numero: telefono.number, pais: telefono.country };
};

export const normalizarTelefonoInternacional = (valor) => {
  const resultado = validarTelefonoInternacional(valor);
  return resultado.valido ? resultado.numero : String(valor || '').trim();
};
